import { render, staticRenderFns } from "./ProcesoCaptura.vue?vue&type=template&id=865a5fe2&"
import script from "./ProcesoCaptura.vue?vue&type=script&lang=js&"
export * from "./ProcesoCaptura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports